import { environment } from "src/environments/environment";

export const BASE_URL = environment.apiBase;
export const END_POINTS = {
    WORK_ORDER: {
        FETCH: `/workorder/get`,
        FETCH_BY_ID: (id: number) => `/workorder/get/${id}`,
        FETCH_APPROVED: `/workorder/approved`,
        CREATE: `/workorder/create`,
        APPROVE: (id: number) => `/workorder/approve/${id}`,
        REJECT: (id: number) => `/workorder/reject/${id}`,
        UPDATE: (id: string) => `/workorder/update/${id}`,
        DELETE: (id: string) => `/workorder/delete/${id}`,
        GET_AMENDMENT: `/workorder/amendmend`,
        AMENDMENT_BY_ID: (id: number) => `/workorder/amendmend/${id}`,
        CREATE_AMENDMENT: `/workorder/amendmend`,
        UPDATE_AMENDMENT: (id: string) => `/workorder/amendmend/${id}`,
        AMENDMENT_APPROVE: (id: number) => `/workorder/amendmend/approve/${id}`,
        AMENDMENT_REJECT: (id: number) => `/workorder/amendmend/reject/${id}`,
        UPLOAD: (id: number) => `/workorder/upload/${id}`,
        FETCH_BY_SITEKEY: (id: string) => `/workorder/get?siteKey=${id}`,
        PRINT: (id: number) => `/export/workorder/${id}`
    },
    BOQ_ENTRY: {
        FETCH: (page: Number)=> `/boqentry/get?page=${page}`,
        SEARCH: (page: Number, search: string)=> `/boqentry/get?page=${page}&search=${search}`,
        APPROVE: (id: number) => `/boqentry/approove/${id}`,
        REJECT: (id: number) => `/boqentry/reject/${id}`,
        CREATE: `/boqentry/create`,
        UPDATE: (id: number) => `/boqentry/update/${id}`,
        FETCH_BOQ_DETAIL_BY_ID: (boqId: number) => `/boqentry/boq/${boqId}/boqdetails`,
        FETCH_BOQ_CODE_BY_ID: (boqId: number) => `/boqentry/boq/${boqId}/boq-codes`,
        FETCH_PRODUCTS_BY_BOQ_CODE_ID: (boqId: number) => `/boqentry/boq/${boqId}/wo-details`,
        IMPORT: (workOrderKey: number) => `/boqentry/upload/workorder/${workOrderKey}/boq`,
        FETCH_BY_ID: (id: number) => `/boqentry/get/${id}`,
        FETCH_AMENDMENT: `/amendment/boqamend/get`,
        FETCH_AMENDMENT_BY_KEY: (boqId: number) => `/amendment/boqamend/get/${boqId}`,
        CREATE_AMENDMENT: (id: number) => `/amendment/${id}`,
        UPDATE_AMENDMENT: (id: number) => `/amendment/${id}`,
        APPROVE_AMENDMENT: (id: number) => `/amendment/approove/${id}`,
        REJECT_AMENDMENT: (id: number) => `/amendment/reject/${id}`,
        FETCH_AMENDMENT_BOQ_DETAIL_BY_ID: (boqId: number) => `/amendment/${boqId}/boqdetails`,
        PRINT: (id: number) => `/export/boq/${id}`,
    },
    WORK_TYPE: {
        FETCH: `/worktype/all`
    },
    PRN_ENTRY: {
        FETCH: `/prnentry/get`,
        FETCH_BY_ID: (id: number) => `/prnentry/get/${id}`,
        CREATE: `/prnentry/create`,
        UPDATE: (id: number) => `/prnentry/update/${id}`,
        APPROVE: (id: any) => `/prnentry/approve/${id}`,
        REJECT: (id: any) => `/prnentry/reject/${id}`,
        DELETE: (id: any) => `/prnentry/delete/${id}`,
        FETCH_BY_SITEKEY: (id: string) => `/prnentry/get-by-site?siteKey=${id}`,
        FETCH_PRODUCT_CODE_BY_PRN_IDS: `/prnentry/purchase/prn`,
        PRINT: (id: number) => `/export/prnentry/${id}`,
    },
    STOCK: {
        UPLOAD: `/stock/openingstock`,
        FETCH: `/stock/get`,
        FETCH_BY_ID: (id: number) => `/stock/get/${id}`,
        CREATE: `/stock/create`,
        UPDATE: (id: number) => `/stock/update/${id}`,
    },
    GRN_ENTRY: {
        FETCH: `/grn/get`,
        FETCH_BY_ID: (id: number) => `/grn/get/${id}`,
        FETCH_DETAILS_BY_ID: (id: number) => `/grn/getDetailsById?id=${id}`,
        CREATE: `/grn/create`,
        UPDATE: (id: number) => `/grn/update/${id}`,
        APPROVE: (id: any) => `/grn/approve/${id}`,
        REJECT: (id: any) => `/grn/reject/${id}`,
        PRINT: (id: number, type:string) => `/export/grn/${id}?type=${type}`,
        FETCH_SITE_FOR_DO :`/grn/deliveryOrderSite`,
        FETCH_FOR_DO: `/grn/deliveryOrder`,
        FETCH_PRODUCT_FOR_DO : `/grn/getProductDetailsForDO`
    },
    PURCHASE_ORDER: {
        FETCH: `/purchaseorder/all`,
        FETCH_BY_ID: (id: number) => `/purchaseorder/get?id=${id}`,
        FETCH_BY_SUPPLIER: (id: number) => `/purchaseorder/all?supplierKey=${id}`,
        CREATE: `/purchaseorder/create`,
        UPDATE: (id: number) => `/purchaseorder/update/${id}`,
        APPROVE: (id: number) => `/purchaseorder/approve/${id}`,
        REJECT: (poId: any) => `/purchaseorder/reject/${poId}`,
        FORCECLOSE: (poId: any) => `/purchaseorder/forceclose/${poId}`,
        PRINT: (id: number) => `/export/po/${id}`,
        FETCH_FOR_DO: `/purchaseorder/deliveryOrder`,
        FETCH_SITE_FOR_DO: `/purchaseorder/deliveryOrderSite`,
        FETCH_PRODUCT_FOR_DO : `/purchaseorder/getProductDetailsForDO`
    },
    DELIVERY_ORDER: {
        FETCH: `/do/all`,
        FETCH_BY_ID: (id: number) => `/do/get?id=${id}`,
        CREATE: `/do/create`,
        UPDATE: (id: number) => `/do/update/${id}`,
        APPROVE: (id: number) => `/do/approve/${id}`,
        REJECT: (poId: any) => `/do/reject/${poId}`,
        PRINT: (id: number) => `/export/do/${id}`,
        FETCH_FOR_DO: `/do/deliveryOrder`,
        FETCH_PRODUCT_FOR_DO : `/do/getProductDetailsForDO`,
        FETCH_DELIVERED_QUANTITY: `/do/getDetailsById`,
    },
    GST: {
        FETCH: `/gst_master/all`
    },
    TOWER: {
        FETCH_ALL : `/tower/all`,
    },
    TERMS: {
        FETCH: `/epterms/all`,
        FETCH_BY_TYPE:(type: string)=> `/epterms/all?type=`+type
    },
    SUPPLIER_BILL:{
        FETCH: `/purchaseinvoice/all`,
        FETCH_BY_ID: (id: number) => `purchaseinvoice/get?id=${id}`,
        CREATE: `/purchaseinvoice/create`,
        UPDATE: (id: number) => `/purchaseinvoice/update/${id}`,
        APPROVE: (id: number) => `/purchaseinvoice/approve/${id}`,
        REJECT: (id: any) => `/purchaseinvoice/reject/${id}`,
    },
    EXPORT_CSV: {
        EXPORT: (module: string) => `/export/csv/${module}`
    },
}